import script from "./edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit.vue?vue&type=script&setup=true&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=4b04b612&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b04b612"]])

export default __exports__